import { resolvers as CartResolvers, typeDefs as CartTypeDefs } from './Cart';
import { merge } from 'lodash';

export const resolvers = merge(CartResolvers);

export const typeDefs = merge(CartTypeDefs);

export default typeDefs;
